import { render } from "./MathemaView.vue?vue&type=template&id=ab25bb1a&ts=true"
import script from "./MathemaView.vue?vue&type=script&lang=ts"
export * from "./MathemaView.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__